import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';

import classnames from '../../../utils/classnames.tsx';
import { withIcon } from '../../Icon.tsx';

const SeparatorIcon = withIcon(faChevronRight);

/** The chevron between two crumbs of a page header; small and light, so the names carry the trail. */
const PageHeaderSeparator = ({ className, ...props }: React.ComponentPropsWithRef<'span'>) => (
    <span
        aria-hidden
        {...props}
        className={classnames('mx-3 flex flex-none items-center text-[10px] text-content-weak', className)}
    >
        <SeparatorIcon />
    </span>
);

export default PageHeaderSeparator;
